import { ReactNode } from 'react'
import { Box, BoxProps, Flex, Heading } from 'ui'
import styled from 'styled-components'
import { SHELL_SM_BREAKPOINT } from './PageContainer'

interface PageProps extends BoxProps {
  title?: string
  headerCtas?: ReactNode
  /** For pages that scroll internally */
  fullHeight?: boolean
  children: ReactNode
}

const PageWrapper = styled(Box).attrs({
  px: [3, 4, 5],
  py: [3, 4],
})``

// The phone top bar shows the title instead
const PageHeader = styled(Flex)`
  display: none;

  @media (min-width: ${SHELL_SM_BREAKPOINT}) {
    display: flex;
  }
`

export const Page = (props: PageProps) => {
  const { title, children, headerCtas, fullHeight, ...boxProps } = props
  const showHeaderBar = title || headerCtas

  return (
    <PageWrapper
      {...(fullHeight ? { height: 'var(--page-full-height)' } : {})}
      {...boxProps}
    >
      {showHeaderBar ? (
        <PageHeader>
          {title ? <Heading level={1}>{title}</Heading> : null}
          <Flex flex={1} alignItems={'center'} justifyContent={'flex-end'}>
            {headerCtas}
          </Flex>
        </PageHeader>
      ) : null}
      {children}
    </PageWrapper>
  )
}
